import api from '@/apis/di/bankInfoAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance } from 'vue';

// Combo grid CTMT
export const useBankAccountComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { proxy } = getCurrentInstance();
  const { extendFilter } = usefilterActionCombo();

  // func call api lấy dữ liệu combo
  const onBankAccountComboboxLoadData = (payload, row, column, custom) => {
    payload.sort = 'bank_account';
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];
    let extend = [{ Field: 'inactive', Value: false, Ors: ors }];
    payload.filter = extendFilter(payload.filter, extend);
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField, custom?.callBackFn);
  };

  // config columns combo
  const bankAccountComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Số tài khoản',
        dataField: 'bank_account',
        width: 180,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      { title: 'Tên NH, KB', dataField: 'bank_name', filterOperator: proxy.$ms.constant.FilterOperator.Contains,width: 420 },
    ],
    displayField: 'bank_account',
    valueField: 'bank_account',
    queryMode: 'remote',
    quickSearch: 'BankInfoQuickSearch',
    quickSearchParam: {
      isFilter: true,
      filterFunc: x => !x.inactive,
    },
    dropdownWidth: 600,
    comboboxLoadData: onBankAccountComboboxLoadData,
  };

  return {
    bankAccountComboConfig,
    onBankAccountComboboxLoadData, // trả về thêm để dùng chung cho cả combo không thuộc grid
  };
};
